export default __webpack_public_path__ + "static/media/high-speed-marker.f6822f3e.png";